import multiguard from "vue-router-multiguard";
import RequiresOrderLocationAcceptingOrdersMiddleware from "./middleware/requires-order-location-accepting-orders";
import RequiresOrderItemsMiddleware from "./middleware/requires-order-items";
import RedirectsIfOrdererHasNoPaymentMethod from "./middleware/redirects-if-orderer-has-no-payment-method";
import RequiresCompletedOrderMiddleware from "./middleware/requires-completed-order";

export default [
  /**
   * these first two are right now restricted to signing up in the app - but they shouldn't necessarily be prefixed "App: "
   */
  {
    path: "/sign-up",
    name: "Sign Up",
    component: () =>
      import(/* webpackChunkName: "sign-up" */ "@/pages/App/SignUp/SignUp"),
    meta: {
      requiresAuth: false,
      requiresGuest: true
    }
  },
  {
    path: "/sign-up/with-email",
    name: "Sign Up With Email",
    component: () =>
      import(
        /* webpackChunkName: "sign-up" */ "@/pages/App/SignUp/SignUpWithEmail"
      ),
    meta: {
      requiresAuth: false,
      requiresGuest: true
    }
  },

  {
    path: "/app/intro",
    name: "App: Intro",
    component: () =>
      import(
        /* webpackChunkName: "the-app" */ "@/pages/App/IntroSlides/IntroSlides"
      ),
    meta: {
      requiresAuth: false
    }
  },

  {
    path: "/app/locations",
    name: "App: Locations",
    component: () =>
      import(/* webpackChunkName: "the-app" */ "@/pages/App/LocationsList"),
    meta: {
      requiresAuth: false
    }
  },

  {
    path: "/app/menu",
    name: "App: Location Menu",
    beforeEnter: RequiresOrderLocationAcceptingOrdersMiddleware,
    component: () =>
      import(/* webpackChunkName: "the-app" */ "@/pages/App/Menu"),
    meta: {
      requiresAuth: false
    }
  },

  {
    path: "/app/order/review",
    name: "App: Order Review and Confirm",
    beforeEnter: multiguard([
      RequiresOrderLocationAcceptingOrdersMiddleware,
      RequiresOrderItemsMiddleware
    ]),
    component: () =>
      import(/* webpackChunkName: "the-app" */ "@/pages/App/OrderReview")
  },

  {
    path: "/app/order/payment/:stripeCardId?",
    name: "App: Order Payment",
    beforeEnter: multiguard([
      RequiresOrderLocationAcceptingOrdersMiddleware,
      RequiresOrderItemsMiddleware,
      RedirectsIfOrdererHasNoPaymentMethod
    ]),
    component: () =>
      import(/* webpackChunkName: "the-app" */ "@/pages/App/OrderPayment")
  },

  {
    path: "/app/order/payment/add-card",
    name: "App: Order Add Card",
    beforeEnter: multiguard([
      RequiresOrderLocationAcceptingOrdersMiddleware,
      RequiresOrderItemsMiddleware
    ]),
    component: () =>
      import(/* webpackChunkName: "the-app" */ "@/pages/App/OrderAddCard")
  },

  {
    path: "/app/order/submitted",
    name: "App: Order Submitted",
    beforeEnter: multiguard([
      RequiresOrderLocationAcceptingOrdersMiddleware,
      RequiresOrderItemsMiddleware,
      RequiresCompletedOrderMiddleware
    ]),
    component: () =>
      import(
        /* webpackChunkName: "the-app" */ "@/pages/App/OrderSubmitted/OrderSubmitted"
      )
  },

  {
    path: "/app/history",
    name: "App: Order History",
    component: () =>
      import(/* webpackChunkName: "the-app" */ "@/pages/App/OrderHistory")
  },

  {
    path: "/app/history/:id",
    name: "App: Order History Detail",
    component: () =>
      import(/* webpackChunkName: "the-app" */ "@/pages/App/OrderHistoryDetail")
  },

  {
    path: "/app/payment-methods",
    name: "App: Payment Methods",
    component: () =>
      import(/* webpackChunkName: "the-app" */ "@/pages/App/PaymentMethodsList")
  },
  {
    path: "/app/payment-methods/add-card",
    name: "App: Payment Method Add Card",
    component: () =>
      import(
        /* webpackChunkName: "the-app" */ "@/pages/App/PaymentMethodsAddCard"
      )
  },
  {
    path: "/app/payment-methods/edit-card/:id",
    name: "App: Payment Method Edit Card",
    component: () =>
      import(
        /* webpackChunkName: "the-app" */ "@/pages/App/PaymentMethodsEditCard"
      )
  }
];
